export const CHECKOUT_URL =
  'https://smartlifesoluciones.com/cart/52042020290776:1'
